/* eslint-disable */
<template>
    <div></div>
</template>

<script>
/* eslint-disable */
    import moment from 'moment-timezone'
    import { StatusEmitterMixin } from '@/mixins/Booking/StatusEmitterMixin';

    export default {
        name: 'ResourceOneOffHoursConflict',
        mixins: [StatusEmitterMixin],
        props: {
            timeSlot: Object,
            value: Object,
            hours: Object
        },
        computed: {
            startTime() {
                return moment(this.timeSlot.startTime).format('HH:mm:ss')
            },
            endTime(){
                return moment(this.timeSlot.endTime).format('HH:mm:ss')
            },
            startLocal() {
                return this.hours.startLocal.split('T')[1];
            },
            endLocal() {
                return this.hours.endLocal.split('T')[1];
            },
            withinWorkingHours() {
                return this.startTime >= this.startLocal && this.endTime <= this.endLocal;
            },
            loading() {
                return false;
            },
            available() {
                return this.hours.dayOff ? false : this.withinWorkingHours;
            }
        }
    }
</script>
